import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3d6e3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper wrapper" }
const _hoisted_2 = { class: "chat_page_wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "chat_info_name" }
const _hoisted_5 = { class: "chat_info_message" }
const _hoisted_6 = { class: "unread_messages_count" }
const _hoisted_7 = { class: "mt-0" }
const _hoisted_8 = { class: "right_side_buttons" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button_exit_img",
  src: "/assets/img/logout.svg"
}, null, -1))
const _hoisted_13 = { class: "" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button_owner_img",
  src: "/assets/img/edit-name-white.svg"
}, null, -1))
const _hoisted_15 = { class: "chat_body_wrapper" }
const _hoisted_16 = { class: "chat_body_top_wrapper" }
const _hoisted_17 = { class: "chat_body_top" }
const _hoisted_18 = { class: "button_text" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button_exit_img",
  src: "/assets/img/logout.svg"
}, null, -1))
const _hoisted_20 = { class: "button_text" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "button_owner_img",
  src: "/assets/img/edit-name-white.svg"
}, null, -1))
const _hoisted_22 = { class: "chat_content_wrapper" }
const _hoisted_23 = {
  class: "chat_body",
  id: "messages"
}
const _hoisted_24 = {
  key: 0,
  class: "info_text"
}
const _hoisted_25 = {
  key: 0,
  class: "technical_message"
}
const _hoisted_26 = { class: "m-0" }
const _hoisted_27 = {
  key: 0,
  class: "message_date"
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 0,
  class: "message_date"
}
const _hoisted_30 = { class: "chat_body_footer" }
const _hoisted_31 = ["title"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "template_button_img",
  src: "/assets/img/document-folder.svg"
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "message_send_button_img",
  src: "/assets/img/send.svg"
}, null, -1))
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx, _cache) {
  const _component_v_input = _resolveComponent("v-input")
  const _component_ChatTemplateDropdown = _resolveComponent("ChatTemplateDropdown")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isShowChatBody ? 'left_side mobile_hide' : 'left_side')
      }, [
        _createVNode(_component_v_input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = $event => ((_ctx.search) = $event)),
            _ctx.searchChat
          ],
          class: "search_input",
          placeholder: _ctx.$t('chat.find_client'),
          height: "22",
          clearable: ""
        }, null, 8, ["modelValue", "placeholder", "onUpdate:modelValue"]),
        _createElementVNode("div", {
          class: "chats_wrapper",
          ref: "chatsWrapper",
          onScrollPassive: _cache[1] || (_cache[1] = (...args) => (_ctx.onListScroll && _ctx.onListScroll(...args)))
        }, [
          _createElementVNode("div", {
            class: "chats_viewport",
            style: _normalizeStyle({ height: _ctx.totalListHeight + 'px' })
          }, [
            _createElementVNode("div", {
              class: "chats_window",
              style: _normalizeStyle({ transform: `translateY(${_ctx.windowOffsetY}px)` })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.windowedRooms, (room) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: room.roomId,
                  class: _normalizeClass([{ chat_wrapper_active: _ctx.selectedRoom && _ctx.selectedRoom?.roomId == room?.roomId }, "chat_wrapper"]),
                  onClick: $event => (_ctx.selectRoom(room))
                }, [
                  _createElementVNode("div", {
                    class: "client_photo",
                    style: _normalizeStyle({ 'background-image': `url(${room.clientPhoto})` })
                  }, null, 4),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ chat_data_wrapper_active: _ctx.selectedRoom && _ctx.selectedRoom?.roomId == room?.roomId }, "chat_data_wrapper"])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(room.unreadMessageCount > 0 ? 'chat_info_wrapper_with_uread_messages' : 'chat_info_wrapper')
                    }, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(room.lastName) + " " + _toDisplayString(room.firstName), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(room.lastMessage), 1)
                    ], 2),
                    _withDirectives(_createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(room.unreadMessageCount > 9 ? '9+' : room.unreadMessageCount), 1)
                    ], 512), [
                      [_vShow, room.unreadMessageCount > 0]
                    ])
                  ], 2)
                ], 10, _hoisted_3))
              }), 128))
            ], 4)
          ], 4)
        ], 544)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isShowChatBody ? 'right_side mobile_show': 'right_side')
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.isShowChatBody = false)),
            class: "button_back"
          }, _hoisted_10),
          (_ctx.selectedRoom?.isOwner)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button_exit_mobile",
                onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.removeOwner && _ctx.removeOwner(...args)))
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('chat.exit_chat')), 1),
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          (!_ctx.selectedRoom?.isOwner)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button_owner_mobile",
                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.assignAsOwner && _ctx.assignAsOwner(...args)))
              }, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('chat.become_owner')), 1),
                _hoisted_14
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", {
                class: "client_photo_body_top",
                style: _normalizeStyle({ 'background-image': `url(${_ctx.selectedRoom?.clientPhoto})` })
              }, null, 4),
              _createElementVNode("div", {
                class: "client_name_body_top",
                onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.redirectToClient && _ctx.redirectToClient(...args)))
              }, _toDisplayString(_ctx.selectedRoom?.lastName) + " " + _toDisplayString(_ctx.selectedRoom?.firstName), 1),
              (_ctx.selectedRoom?.isOwner)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button_exit",
                    onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.removeOwner && _ctx.removeOwner(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('chat.exit_chat')), 1),
                    _hoisted_19
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.selectedRoom?.isOwner)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button_owner",
                    onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.assignAsOwner && _ctx.assignAsOwner(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('chat.become_owner')), 1),
                    _hoisted_21
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.selectedRoom]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "overflow-hidden",
              style: _normalizeStyle({ 'min-height': `calc(100% - ${36 + _ctx.textareaHeight}px)` })
            }, [
              _createElementVNode("div", _hoisted_23, [
                (_ctx.messageInformation)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.messageInformation ? _ctx.$t(_ctx.messageInformation) : _ctx.messageInformation), 1))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.messages, (message) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        (message.isTechnicalMessage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("p", _hoisted_26, _toDisplayString(message.isTranslated ? _ctx.$t(message.text) : message.text), 1),
                              (!message.isTechnicalMessage)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(message.sendDate), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(message.isClubMessage ? 'club_message' : 'client_message')
                            }, [
                              _createElementVNode("p", {
                                class: "m-0",
                                innerHTML: message.text
                              }, null, 8, _hoisted_28),
                              (!message.isTechnicalMessage)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(message.sendDate), 1))
                                : _createCommentVNode("", true)
                            ], 2))
                      ]))
                    }), 256))
              ])
            ], 4),
            _createElementVNode("div", {
              class: "chat_body_footer_wrapper",
              style: _normalizeStyle({ 'min-height': `${36 + _ctx.textareaHeight}px` })
            }, [
              _createVNode(_component_ChatTemplateDropdown, {
                show: _ctx.isTemplatesOpen,
                templates: _ctx.templates,
                loading: _ctx.isTemplatesLoading,
                error: _ctx.templatesError,
                onSelect: _ctx.selectTemplate,
                onClose: _cache[8] || (_cache[8] = $event => (_ctx.isTemplatesOpen = false))
              }, null, 8, ["show", "templates", "loading", "error", "onSelect"]),
              _withDirectives(_createElementVNode("div", _hoisted_30, [
                (_ctx.showTemplatesButton)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["template_button", { template_button_active: _ctx.isTemplatesOpen }]),
                      onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.toggleTemplates && _ctx.toggleTemplates(...args))),
                      title: _ctx.$t('chat.templates')
                    }, _hoisted_33, 10, _hoisted_31))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["textarea_wrapper", { active: _ctx.isTextareaFocused, 'no-template-button': !_ctx.showTemplatesButton }])
                }, [
                  _withDirectives(_createElementVNode("textarea", {
                    placeholder: _ctx.$t('chat.enter_message'),
                    class: "textarea",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.message) = $event)),
                    onKeydown: _cache[11] || (_cache[11] = $event => (_ctx.updateTextarea($event))),
                    onInput: _cache[12] || (_cache[12] = (...args) => (_ctx.changeTextArea && _ctx.changeTextArea(...args))),
                    onFocus: _cache[13] || (_cache[13] = $event => (_ctx.isTextareaFocused = true)),
                    onBlur: _cache[14] || (_cache[14] = $event => (_ctx.isTextareaFocused = false)),
                    id: "messageTextarea"
                  }, null, 40, _hoisted_34), [
                    [_vModelText, _ctx.message]
                  ])
                ], 2),
                _createElementVNode("button", {
                  class: "message_send_button",
                  onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                }, _hoisted_36)
              ], 512), [
                [_vShow, _ctx.selectedRoom?.isOwner && !_ctx.connectionInformation]
              ]),
              _withDirectives(_createElementVNode("p", { class: "info_text" }, _toDisplayString(_ctx.connectionInformation ? _ctx.$t(_ctx.connectionInformation) : _ctx.connectionInformation), 513), [
                [_vShow, _ctx.connectionInformation]
              ])
            ], 4)
          ])
        ])
      ], 2)
    ])
  ]))
}